import "../css/profileCta.css";
import ParticlesBg from "particles-bg";
import troyProfilePic from "../images/troyWarnerProHeadshot.jpg";

function ProfileCta() {
  return (
    <div className="profileCta-div">
      <div className="particle-bg">
        <ParticlesBg
          color="#2ca4f2"
          num={75}
          type="cobweb"
          bg={true}
          config={{ rps: 0.00001 }}
        />
      </div>
      <div className="profileCta-grid">
        <img
          className="troyProfilePic"
          src={troyProfilePic}
          alt="Troy Warner Mortgage Banker"
        />
        <div>
          <h2 className="profileName">Troy Warner</h2>
          <h3 className="NMLS">Mortgage Banker (NMLS #102983)</h3>
          <p className="profileP">
            Hello! I’m Troy, I look forward to helping you along your home
            buying experience. I’ve provided a few useful links to get you
            started.
          </p>
          <a href="#getStarted" className="buttonBlue">
            Get Started
          </a>
        </div>
      </div>
    </div>
  );
}

export default ProfileCta;
